/**
 * <SelectClassStudent
 *	/>
 *
 * @parent anybody
 * @stateful
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import SelectClassStudentModal from 'template/Modals/SelectClassStudent';
import './SelectItems.scss';
import { ITEM_NAME_LIST_LENGTH } from '../constants';
import Student from 'mediators/Student';
import parseJson from '../parseJson';

export function selectClassStudent (props) {
  let value = parseJson(props.value);

  let {
    mixin,
  } = props.schema;

  return (
    <SelectClassStudent
      {...props}
      mixin={mixin}
      value={value}
      onChange={(data)=>{ props.onChange(JSON.stringify(data)); }} />
  );
}

class SelectClassStudent extends React.Component {
  static propTypes = {

  }

  static defaultProps = {
  }

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);

    this.state = {
      studentNames: [],
      studentIds: [],
      selected: this.convertToStudentMediator(props.value || []),
    }

    props.value.map((student) => {
      this.setState({studentNames: student.student_name})
    })

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value) {
      this.setState({
        selected: this.convertToStudentMediator(nextProps.value),
      });
    }
  }

  convertToStudentMediator(value) {
    return value.map((raw)=>{
      return new Student(raw);
    });
  }

  convertToObject(value) {
    if([value].length == 1 && !Array.isArray(value) ){
      return value.toObject()
    } else {
      return value.map((prox)=>{
        return prox.toObject();
      });
    }
  }

  onChange() {
    let {
      options,
      onChange,
      selectFilter,
    } = this.props;

    let {
      conflictedIDs,
      selectMultiple,
    } = options;

    let {
      selected,
    } = this.state;

    const schoolId = localStorage.getItem('schoolId');

    SelectClassStudentModal({
      conflictedIDs,
      schoolId,
      selectMultiple,
      selected,
    })
      .then((studentsOut)=>{
        let studentNames = [];
        let studentIds = [];
        let selected = [];

        if (!Array.isArray(studentsOut)) {
          selected = [this.convertToObject(studentsOut)];
        } else {
          selected = this.convertToObject(studentsOut);
        }

        selected.map((student)=>{
          studentNames.push(student.name);
          studentIds.push(student.id);
        });

        this.setState({
          studentNames,
          studentIds,
          selected,
        });

        onChange(selected);
      })
      .catch((err)=>{
        console.error(err);
      });
  }

  render() {
    let {
      selected,
    } = this.state;

    let {
      disableSelect,
    } = this.props.options;

    let studentNamesText;

    if (selected.length > 0) {
      let arr = []

      selected.map((s) => {
        arr.push(s.name)
      })

      studentNamesText = arr.join(', ')
    } else {
      studentNamesText = <span className='no-items'>{__('Not Assigned', 'classdetail')}</span>;
    }

    return (
      <div className='select-items-button'>
        <div className='item-names'>
          {studentNamesText}
        </div>
          { disableSelect !== true && <a className='select-button' onClick={this.onChange} >{__('Select', 'class')}</a> }
      </div>
    )
  }
}

export default SelectClassStudent;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/SelectClassStudent.js